import { createContext, useReducer, useEffect, useMemo } from "react";
// firestore
import { onSnapshot, doc } from "firebase/firestore";
import { db } from "../services/firebase";
// products
import actionTypes from "../common/actionTypes";
import { statReducer } from "../reducers";
// context
import useAuthContext from "../hooks/useAuthContext";
// constants
import { DATABASE_STATUTES } from "../common/constants";
// utils
import { fBigNumber } from "../utils/formatNumber";

// stats constants
// const SHOPS = "Shops";
// const STATS = "Stats";
const TOTAL_STATS = "Stats";

const initialState = {
  shopStat: [],
  totalStat: { revenue: 0, preorders: 0, orders: 0, preorderItems: 0 },
  status: DATABASE_STATUTES.NOT_LOADED,
  error: null,
};

const StatsContext = createContext({
  ...initialState,
});

const StatsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(statReducer, initialState);

  const { user } = useAuthContext();

  useEffect(() => {
    if (user) {
      dispatch({
        type: actionTypes.FETCH_TOTAL_STATS,
      });

      try {
        return onSnapshot(doc(db, TOTAL_STATS, user.domain), (doc) => {
          const stat = doc.data();

          dispatch({
            type: actionTypes.FETCH_TOTAL_STATS_SUCCESS,
            payload: {
              ...stat,
              revenue: `${stat?.revenue.preorders ? fBigNumber(stat.revenue.preorders) : 0} ${
                stat?.revenue.currency || "USD"
              }`,
            },
          });
        });
      } catch (error) {
        dispatch({
          type: actionTypes.FETCH_TOTAL_STATS_FAILURE,
          payload: error,
        });
      }
    }
  }, [user]);

  const memoizedState = useMemo(() => state, [state]);

  return <StatsContext.Provider value={memoizedState}>{children}</StatsContext.Provider>;
};

export { StatsContext, StatsProvider };
